import { registerMutation } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { Contact } from '@adornis/digitale-helden-shared/db/Contact.js';
import { UpsertContactOptions } from '@adornis/digitale-helden-shared/db/UpsertContactOptions.js';
import { getContactEmailStatusByEmail } from '../queries/getContactEmailStatusByEmail.js';
import { sendContactDOIMail } from './sendContactDOIMail.js';
import { upsertContact } from './upsertContact.js';

export const upsertContactAndCheckDOI = registerMutation({
  type: () => Contact,
  operationName: 'upsertContactAndCheckDOI',
  resolve: (contact: Contact, createAccount: boolean, options?: UpsertContactOptions, redirectURL?: string) => {
    return async (gqlFields: BaseQLSelectionSet<Contact>) => {
      try {
        const emailStatus = await getContactEmailStatusByEmail(contact.email)();
        contact.emailStatus = emailStatus;
      } catch {}
      contact = await upsertContact(contact, options)(Contact.allFields);

      // try to send DOI mail
      await sendContactDOIMail(contact.id ?? '', createAccount, redirectURL)();

      return contact;
    };
  },
  params: [
    { name: 'contact', type: () => Contact },
    { name: 'createAccount', type: () => Boolean },
    { name: 'options', type: () => UpsertContactOptions },
    { name: 'redirectURL', type: () => String },
  ],
});
